import { z } from 'zod';
import { StepTemplateDescriptionSchema, StepTemplateNameSchema, StepTemplateSchema } from '../../entities/step-template/step-template.schema';
/**
 * PATCH /api/v2/step-template/:id — request. Only the metadata is editable;
 * the snapshotted nodes are immutable.
 */ export const UpdateStepTemplateRequestSchema = z.object({
    name: StepTemplateNameSchema.optional(),
    description: StepTemplateDescriptionSchema.optional()
}).refine((body)=>Object.values(body).some((value)=>value !== undefined), {
    message: 'At least one field must be provided'
});
export const UpdateStepTemplateResponseSchema = z.object({
    data: StepTemplateSchema
});

//# sourceMappingURL=update-step-template.schema.js.map